var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 11.9833C16.6165 10.8667 17.7498 9.03332 17.7498 7.33332C17.7498 3.56666 14.8332 0.666656 11.0832 0.666656H0.666504V24H12.3998C15.8832 24 18.5832 21.1667 18.5832 17.6833C18.5832 15.15 17.1498 12.9833 14.9998 11.9833ZM5.6665 4.83332H10.6665C12.0498 4.83332 13.1665 5.94999 13.1665 7.33332C13.1665 8.71666 12.0498 9.83332 10.6665 9.83332H5.6665V4.83332ZM11.4998 19.8333H5.6665V14.8333H11.4998C12.8832 14.8333 13.9998 15.95 13.9998 17.3333C13.9998 18.7167 12.8832 19.8333 11.4998 19.8333Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/Bold.b7296b865aab5cccbea0ace97ee411c8.svg";
export { ForwardRef as ReactComponent };